import { Stack } from '@mui/material';
import React, { ReactNode } from 'react';

import styles from './Folded2025Card.module.scss';

interface Folded2025CardProps {
	children: ReactNode;
	className?: string;
	style?: React.CSSProperties;
	icon?: React.ReactNode;
}

interface TextComponentProps {
	children: ReactNode;
	className?: string;
	style?: React.CSSProperties;
	size?: string;
	font?: string;
}

const Folded2025Card = ({
	children,
	className,
	style,
	icon,
}: Folded2025CardProps): JSX.Element => {
	return (
		<Stack className={`${styles.card} ${className || ''}`} style={style}>
			{children}
			{icon && <div className={styles.cardIcon}>{icon}</div>}
		</Stack>
	);
};

const Label = ({ children, className, style, size }: TextComponentProps): JSX.Element => {
	const sizeClass = size ? styles[`cardLabel_${size}`] : '';
	return (
		<div
			className={`${styles.cardLabel} ${sizeClass} ${className || ''}`}
			style={style}
		>
			{children}
		</div>
	);
};

const Value = ({
	children,
	className,
	style,
	size,
	font,
}: TextComponentProps): JSX.Element => {
	const sizeClass = size ? styles[`cardValue_${size}`] : '';
	const fontClass = font ? styles[`cardValue_${font}`] : '';
	return (
		<div
			className={`${styles.cardValue} ${sizeClass} ${fontClass} ${className || ''}`}
			style={style}
		>
			{children}
		</div>
	);
};

const Subtext = ({
	children,
	className,
	style,
	size,
}: TextComponentProps): JSX.Element => {
	const sizeClass = size ? styles[`cardSubtext_${size}`] : '';
	return (
		<div
			className={`${styles.cardSubtext} ${sizeClass} ${className || ''}`}
			style={style}
		>
			{children}
		</div>
	);
};

const SubtextIcon = ({
	children,
	className,
	style,
	size,
}: TextComponentProps): JSX.Element => {
	const sizeClass = size ? styles[`cardSubtextIcon_${size}`] : '';
	return (
		<span
			className={`${styles.cardSubtextIcon} ${sizeClass} ${className || ''}`}
			style={style}
		>
			{children}
		</span>
	);
};

const Icon = ({ children, className, style, size }: TextComponentProps): JSX.Element => {
	const sizeClass = size ? styles[`cardIcon_${size}`] : '';
	return (
		<div
			className={`${styles.cardIcon} ${sizeClass} ${className || ''}`}
			style={style}
		>
			{children}
		</div>
	);
};

Folded2025Card.Label = Label;
Folded2025Card.Value = Value;
Folded2025Card.Subtext = Subtext;
Folded2025Card.SubtextIcon = SubtextIcon;
Folded2025Card.Icon = Icon;

export default Folded2025Card;
